// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nxZvD","content":"styles_content__2CRie"};